import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compareFechaActualFechaFija, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';

import SinResultadosPorFecha from '../../../../assets/images/SinResultadosFecha.png';

import * as actions from '../../../../store/actions/index';
import TextChart from '../../../Charts/TextChart';
import { seccionRestringidaPorPlan } from '../../../../shared/seccionesPorPlan';

const TextoChequesPropios = (props) => {
  const restringidoPorPlan = !props.empresa && seccionRestringidaPorPlan('chequesEmitidos');

  useEffect(() => {
    if (!props.estaCargado && !props.empresa && !props.estaOculto && !restringidoPorPlan && props.ejecucionDePagina) {
      props.onLoadChart();
    }
    if (props.empresa) {
      props.onLoadChart(props.empresa.id);
    }

    return () => {
      if (props.empresa) {
        props.onUnmountChart();
      }
    };
  }, [props.ejecucionDePagina]);

  // La restricción por plan gana sobre la imagen de fecha fija: fuerza la rama imgSinDatos.
  const isDisabledChart =
    !restringidoPorPlan && ((props.estaOculto && !props.empresa) || !compareFechaActualFechaFija());

  return (
    <TextChart
      title={`Cheques emitidos pendientes ${
        props.empresa ? props.empresa.nombre : ''
      } al ${fechaFinPeriodoMesActualFunc()}`}
      bigAmount={props.monto}
      bigAmountTooltip=""
      smallAmount={`${props.promedioDias}`}
      smallAmountTooltip="Prom. días de vencimiento"
      bigCurrency
      customDisabledImage={!compareFechaActualFechaFija() && !props.estaOculto ? SinResultadosPorFecha : undefined}
      disabled={isDisabledChart}
      imgSinDatos={restringidoPorPlan}
      sinAccesoPorPlan={restringidoPorPlan}
      cursorPointer={!isDisabledChart && !restringidoPorPlan}
      loading={props.loading}
      onBodyClick={props.onBodyClick}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.compras.textoChequesPropios.loading,
    monto: state.compras.textoChequesPropios.monto,
    promedioDias: state.compras.textoChequesPropios.promedioDias,
    estaCargado: state.compras.textoChequesPropios.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.chequesEmitidos
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: (idEmpresa) => dispatch(actions.loadTextoChequesPropios(idEmpresa)),
    onUnmountChart: () => dispatch(actions.clearTextoChequesPropios())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoChequesPropios);
